import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import API from '../../../src/config/axios.config';
import { API_ENDPOINTS } from '../../../src/shared/api-endpoints';

interface RenameSliceState {
	renameResponse: any;
	status: boolean;
	error: string | null;
}

const initialState: RenameSliceState = {
	renameResponse: {},
	status: false,
	error: null
};

const renameChat = createAsyncThunk<any, any>('renameChat/renameChat', async (payload, thunkAPI) => {
	try {
		const response = await API.patch(API_ENDPOINTS.RENAME_CHAT, payload);
		return response.data;
	} catch (error: any) {
		return error.response.data;
	}
});

const renameSlice = createSlice({
	name: 'renameChat',
	initialState,
	reducers: {
		reset: () => initialState
	},
	extraReducers: (builder) => {
		builder
			.addCase(renameChat.pending, (state) => {
				state.status = true;
				state.error = null;
			})
			.addCase(renameChat.fulfilled, (state, action: PayloadAction<any>) => {
				state.status = false;
				state.renameResponse = action.payload;
			})
			.addCase(renameChat.rejected, (state, action) => {
				state.status = false;
				state.error = action.error.message || 'Failed to rename chat';
			});
	}
});

export { renameChat };
export const { reset: resetRenameSlice } = renameSlice.actions;
export const renameSliceReducer = renameSlice.reducer;
